import {z} from 'zod';

const categoryCreateSchema = z.object({
    name: z.string()
        .min(1, {message: "Název kategorie musí mít alespoň 1 znak"})
        .max(50, {message: "Název kategorie může mít maximálně 50 znaků"}),
    categoryNumber: z.number({
        required_error: "Číslo kategorie je povinné",
        invalid_type_error: "Číslo kategorie musí být platné číslo",
    }).positive("Číslo kategorie musí být kladné"),
    description: z.string()
        .optional()
        .nullable()
});

type CategoryCreateRequest = z.infer<typeof categoryCreateSchema>;

export {categoryCreateSchema, type CategoryCreateRequest};